import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import ContactHero from "./components/ContactHero";
import FaqAccordion from "./components/FaqAccordion";
import ContactForm from "./components/ContactForm";

export default function Contact() {
  return (
    <main className="min-h-screen font-inter">
      <Navbar />
      <ContactHero />
      <FaqAccordion />
      <ContactForm />
      <Footer />
    </main>
  );
}
